import * as React from "react";
import styled, { css } from "styled-components";

import { LoadingSpinner } from "src/library/components/LoadingSpinner";
import { Text } from "src/library/components/Text/Text";

import CustomerCallOffRow from "./customerCallOffRows";
import useCallOffs from "../hooks/useCallOffs";

const CustomerCallOffDashboardWidget: React.ReactFCWithChildren = () => {
  const { callOffs, loadingCallOffs } = useCallOffs();
  const [ display, setDisplay ] = React.useState<"small" | "large">("large");
  const wrapperRef = React.createRef<HTMLDivElement>();

  React.useEffect(() => {
    if (!wrapperRef.current) {
      return;
    }

    const observer = new ResizeObserver(entries => {
      for (const entry of entries) {
        const width = entry.contentRect.width;

        if (width > 650) {
          setDisplay("large");
        } else {
          setDisplay("small");
        }
      }
    });

    observer.observe(wrapperRef.current);

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <CustomerCallOffDashboardWidgetWrapper
      ref={wrapperRef}
      display={display}
    >
      {loadingCallOffs ? (
        <LoadingSpinner
          type="circular-pulse"
          size={30}
        />
      ) : (
        <div className="call-off-list">
          {callOffs?.length ? callOffs?.map(co => (
            <CustomerCallOffRow
              key={co.id}
              callOff={co}
              display={display}
            />
          )) : (
            <Text>
              You have no call-offs
            </Text>
          )}
        </div>
      )}
    </CustomerCallOffDashboardWidgetWrapper>
  );
};

export default CustomerCallOffDashboardWidget;

const CustomerCallOffDashboardWidgetWrapper = styled.div<{display: "small" | "large"}>`
  ${({ theme, display }) => css`
    height: 100%;
    background: ${theme.colors.white};
    display: flex;
    flex-direction: ${display === "small" ? "row" : "column"};

    .call-off-list {
      display: flex;
      justify-content:center;
      width:100%;
      flex-wrap:wrap;
      overflow-y: scroll;
      height: 100%;
    }
    

  `}
`;
